import { render, staticRenderFns } from "./SamplePickup.vue?vue&type=template&id=df867f52"
import script from "./SamplePickup.vue?vue&type=script&lang=js"
export * from "./SamplePickup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports